import { render, staticRenderFns } from "./certificate-review-table.vue?vue&type=template&id=4f263807&scoped=true"
import script from "./certificate-review-table.vue?vue&type=script&lang=js"
export * from "./certificate-review-table.vue?vue&type=script&lang=js"
import style0 from "./certificate-review-table.vue?vue&type=style&index=0&id=4f263807&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f263807",
  null
  
)

export default component.exports